import BaseController from "confinus_ui/base_controller";

export default class SideNavbarSubItemController extends BaseController {
  public static targets = ["title", "link"];

  declare private readonly titleTarget: HTMLHeadingElement;
  declare private readonly linkTarget: HTMLAnchorElement;
  declare private readonly hasLinkTarget: boolean;

  public static classes = ["shown", "filtered", "active", "inactive"];
  declare protected readonly filteredClasses: string[];
  declare protected readonly shownClasses: string[];
  declare protected readonly activeClasses: string[];
  declare protected readonly inactiveClasses: string[];

  public filterOnSearch(keyword: string): boolean {
    return this.toggleOnSearch(
      keyword,
      this.element,
      [this.titleTarget],
      this.shownClasses,
      this.filteredClasses,
    );
  }

  // Re-derive whether this sub-item points at the current page (or a page nested
  // beneath it) and update its highlight. Returns true when active so the parent
  // group knows to expand. Mirrors MainMenuItems#nav_path_active? server-side.
  public syncActiveForPath(path: string): boolean {
    if (!this.hasLinkTarget) return false;

    const href = this.linkTarget.getAttribute("href") || "";
    let linkPath: string;
    try {
      linkPath = new URL(href, window.location.origin).pathname;
    } catch {
      return false;
    }

    const active = linkPath === path || path.startsWith(`${linkPath}/`);
    this.toggleTargetElementClasses(
      this.linkTarget,
      active,
      this.inactiveClasses,
      this.activeClasses,
    );
    return active;
  }
}
